<td>{{ user.lastName }}</td>
<td>{{ user.firstName }}</td>
<td>{{ user.userName }}</td>
<td>{{ user.isActive ? ('active' | translate) : ('deactivated' | translate) }}</td>
<td>
  <div *ngFor="let r of user.roles" class="flex items-center justify-center">
    <p-tag class="my-1" [value]="getRoleName(r) | translate" [severity]="getRoleSeverity(r)" [rounded]="true" />
  </div>
</td>
<td>
  @if(!showDisabled) {
  <p-button variant="outlined" icon="pi pi-trash" (click)="onDelete($event)" />
  }
</td>
<td>
  @if(!showDisabled) {
  <p-button [disabled]="showDisabled" (click)="onShowDialog()">
    @if(isShowing) {
    <i class="pi pi-spin pi-spinner"></i>
    } @else {
    <i class="pi pi-user-edit"></i>
    }
  </p-button>
  }
</td>
